import '../components/asset-rate-card';
import '../components/asset-update-online-price';

Vue.component('inventory-manager', {
    data() {
        return {
            loading: false,
            config: {
                tableClass: 'table w-100',
                columns: [
                    {
                        key: 'favorite',
                        label: '',
                        sortable: true,
                        classes: 'favorite-column',
                    },
                    { key: 'name', label: 'Asset Name', sortable: true },
                    { key: 'category', label: 'Category', sortable: true },
                    { key: 'rate_card', label: 'Rate Card', sortable: true },
                    {
                        key: 'online_price',
                        label: 'Online Base Price',
                        sortable: true,
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true,
                        classes: 'active-column',
                    },
                    { key: 'actions', label: '', classes: 'actions-column' },
                ],
            },
            query: {
                perPage: 25,
                include: 'category',
                append: 'asset_images',
                sort: '-favorite,name',
                filter: {
                    status: '0,1,2',
                    search: null,
                    favorite: null,
                    category: [],
                },
            },
        };
    },
    computed: {
        filterAll: {
            get() {
                return !this.query.favorite && this.query.filter.status === '0,1,2';
            },
            set() {
                this.query.filter.favorite = null;
                this.query.filter.status = '0,1,2';
                this.$refs.inventoryTable.refresh();
            },
        },
        filterFavorite: {
            get() {
                return this.query.filter.favorite && this.query.filter.status === '0,1,2';
            },
            set() {
                this.query.filter.favorite = 1;
                this.query.filter.status = '0,1,2';
                this.$refs.inventoryTable.refresh();
            },
        },
        filterHidden: {
            get() {
                return !this.query.filter.favorite && this.query.filter.status === '3';
            },
            set() {
                this.query.filter.favorite = null;
                this.query.filter.status = '3';
                this.$refs.inventoryTable.refresh();
            },
        },
        filterNotHidden: {
            get() {
                return !this.query.filter.favorite && this.query.filter.status === '0,1,2';
            },
            set() {
                this.query.filter.favorite = null;
                this.query.filter.status = '0,1,2';
                this.$refs.inventoryTable.refresh();
            },
        },
    },
    created() {
        Bus.$on('assetUpdated', this.refresh);
        Bus.$on('assetFavoriteToggle', this.refresh);
        Bus.$on('assetHideToggle', this.refresh);
        Bus.$on('assetDuplicated', this.refresh);
        Bus.$on('categoryFilterSelect', this.filterCategory);
    },
    beforeDestroy() {
        Bus.$off('assetUpdated', this.refresh);
        Bus.$off('assetFavoriteToggle', this.refresh);
        Bus.$off('assetHideToggle', this.refresh);
        Bus.$off('assetDuplicated', this.refresh);
        Bus.$off('categoryFilterSelect', this.filterCategory);
    },
    methods: {
        refresh() {
            this.$refs.inventoryTable.refresh();

        },
        filterCategory(payload) {
            this.query.filter.category = payload;
        },
    },
});
